import { push } from 'react-router-redux';
import { withApollo, graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import { connect } from 'react-redux';
import { clearSessionStorage } from '../../utils/auth';
import LogoutPage from './index';

// GraphQL query for removing token, resetting the Apollo Store, and logout.
const userLogout = gql`
  mutation {
    logout
  }
`;

// Create graphql HOC.
let LogoutWithData = withApollo(
  compose(
    graphql(userLogout, {
      props: ({ ownProps: { redirectToRoot, client }, mutate }) => {
        return {
          onLogout: () => {
            return mutate()
              .then(({ data }) => {
                clearSessionStorage();
                client.resetStore();
                client.recreateWebSocketConnection();

                redirectToRoot();

                return data;
              })
              .catch(err => {
                clearSessionStorage();
                client.resetStore();
                client.recreateWebSocketConnection();

                redirectToRoot();
              });
          }
        };
      }
    })
  )(LogoutPage)
);

function mapDispatchToProps(dispatch) {
  return {
    redirectToRoot: () => dispatch(push('/'))
  };
}

export default connect(null, mapDispatchToProps)(LogoutWithData);



// WEBPACK FOOTER //
// ./src/containers/LogoutPage/LogoutWithData.js